import moment from 'moment';
import { isEmpty } from 'lodash';

import UserName from '../../../containers/user-name';

import './style.styl';

/**
 * getUsersTimeZone
 * Get the User timezone settings
 *
 * @returns		{object}	timeZoneObject
 */
const getUsersTimezone = (timeZoneObject = {}) => {
	if(!isEmpty(timeZoneObject?.user) && !!timeZoneObject?.user?.timezone) {
		return timeZoneObject.user
	}
	if(!isEmpty(timeZoneObject?.company) && !!timeZoneObject?.company?.timezone) {
		return timeZoneObject.company
	}
	try {
		const browser = Intl.DateTimeFormat().resolvedOptions();
		if(!isEmpty(browser)) {
			return {
				locale: browser.locale,
				timezone: browser.timeZone,
			}
		}
		return false;
	} catch {
		return {
			locale: moment.locale(),
			timezone: moment.tz.guess()
		}
	}
};


const getFormattedTime = (item, timezones) => {
	const createdAt = item.createdDate || item.createdAt;
	const isIso8601 = moment(createdAt, moment.ISO_8601, true).isValid();
	const timezone = !isEmpty(timezones) ? getUsersTimezone(timezones)?.timezone : '';

	if (isIso8601) {
		const isDateOnly = moment(createdAt, 'YYYY-MM-DD', true).isValid();
		if (isDateOnly) {
			return moment(createdAt).format();
		}
		return timezone ? moment.utc(createdAt).tz(timezone).calendar() : moment.utc(createdAt).local().calendar();
	}
	return timezone ? moment.unix(createdAt).tz(timezone).calendar() : moment.unix(item.createdAt).calendar();

};

const Header = ({ item, timezones }) => (
	<div className="FeedListItem__info">
		<div className="FeedListItem__userName">
			<UserName id={ item.author } />
		</div>
		{ item.categoryName && (
			<div className="FeedListItem__category">
				{ item.categoryName }
			</div>
		) }
		<div className="FeedListItem__timeStamp" data-date={ item.createdAt }>
			{ getFormattedTime(item, timezones) }
			{ item.edited && ` - ${ $.__('Edited') }` }
		</div>
	</div>
);

export default Header;

